export const CreateNewReservationIcon = () => {
  return (
    <svg
      width="193"
      height="77"
      viewBox="0 0 193 77"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="30.6968"
        y="8.10156"
        width="26.1418"
        height="26.1418"
        rx="7.71"
        fill="url(#paint0_linear_1868_3367)"
      />
      <rect
        x="30.6968"
        y="8.10156"
        width="26.1418"
        height="26.1418"
        rx="7.71"
        fill="black"
        fillOpacity={0.1}
      />
      <foreignObject x="28.3889" y="6.10255" width="31.6009" height="30.1191">
        <div
          style={{
            backdropFilter: "blur(3.21px)",
            clipPath: "url(#bgblur_0_1868_3367_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <g
        opacity="0.4"
        filter="url(#filter0_i_1868_3367)"
        data-figma-bg-blur-radius="6.41894"
      >
        <rect
          x="34.8078"
          y="29.8027"
          width="17.2818"
          height="18.7631"
          rx="6"
          transform="rotate(-90 34.8078 29.8027)"
          fill="url(#paint1_linear_1868_3367)"
        />
        <rect
          x="35.0053"
          y="29.6052"
          width="16.8867"
          height="18.368"
          rx="5.80249"
          transform="rotate(-90 35.0053 29.6052)"
          stroke="url(#paint2_linear_1868_3367)"
          strokeWidth="0.395012"
        />
      </g>
      <rect
        x="63.135"
        y="0.523438"
        width="67.0129"
        height="41.2992"
        rx="9.39"
        fill="url(#paint3_linear_1868_3367)"
      />
      <rect
        x="63.135"
        y="0.523438"
        width="67.0129"
        height="41.2992"
        rx="9.39"
        fill="black"
        fillOpacity={0.1}
      />
      <foreignObject x="61.7601" y="-0.952044" width="69.7632" height="45.115">
        <div
          style={{
            backdropFilter: "blur(2.74px)",
            clipPath: "url(#bgblur_1_1868_3367_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <g
        opacity="0.5"
        filter="url(#filter1_i_1868_3367)"
        data-figma-bg-blur-radius="5.48134"
      >
        <rect
          x="67.2414"
          y="38.6816"
          width="34.153"
          height="58.8005"
          rx="7.44"
          transform="rotate(-90 67.2414 38.6816)"
          fill="url(#paint4_linear_1868_3367)"
        />
        <rect
          x="67.4101"
          y="38.513"
          width="33.8157"
          height="58.4632"
          rx="7.27134"
          transform="rotate(-90 67.4101 38.513)"
          stroke="url(#paint5_linear_1868_3367)"
          strokeWidth="0.337313"
        />
      </g>
      <rect
        x="136.445"
        y="8.10156"
        width="26.1418"
        height="26.1418"
        rx="7.71"
        fill="url(#paint6_linear_1868_3367)"
      />
      <rect
        x="136.445"
        y="8.10156"
        width="26.1418"
        height="26.1418"
        rx="7.71"
        fill="black"
        fillOpacity={0.1}
      />
      <foreignObject x="134.137" y="6.10255" width="31.6009" height="30.1191">
        <div
          style={{
            backdropFilter: "blur(3.21px)",
            clipPath: "url(#bgblur_2_1868_3367_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <g
        opacity="0.4"
        filter="url(#filter2_i_1868_3367)"
        data-figma-bg-blur-radius="6.41894"
      >
        <rect
          x="140.555"
          y="29.8027"
          width="17.2818"
          height="18.7631"
          rx="6"
          transform="rotate(-90 140.555 29.8027)"
          fill="url(#paint7_linear_1868_3367)"
        />
        <rect
          x="140.753"
          y="29.6052"
          width="16.8867"
          height="18.368"
          rx="5.80249"
          transform="rotate(-90 140.753 29.6052)"
          stroke="url(#paint8_linear_1868_3367)"
          strokeWidth="0.395012"
        />
      </g>
      <rect
        x="83.6041"
        y="50.8223"
        width="26.0749"
        height="26.0749"
        rx="6.53129"
        fill="url(#paint9_linear_1868_3367)"
      />
      <rect
        x="83.6041"
        y="50.8223"
        width="26.0749"
        height="26.0749"
        rx="6.53129"
        fill="black"
        fillOpacity={0.1}
      />
      <path
        d="M95.6141 57.3535H97.6686V70.3658H95.6141V57.3535Z"
        fill="white"
      />
      <path d="M90.135 62.832H103.147V64.8866H90.135V62.832Z" fill="white" />
      <defs>
        <filter
          id="filter0_i_1868_3367"
          x="28.3889"
          y="6.10255"
          width="31.6009"
          height="30.1191"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="4.93765"
            operator="erode"
            in="SourceAlpha"
            result="effect1_innerShadow_1868_3367"
          />
          <feOffset dx="-2.96259" dy="2.96259" />
          <feGaussianBlur stdDeviation="1.97506" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1868_3367"
          />
        </filter>
        <clipPath
          id="bgblur_0_1868_3367_clip_path"
          transform="translate(-28.3889 -6.10255)"
        >
          <rect
            x="34.8078"
            y="29.8027"
            width="17.2818"
            height="18.7631"
            rx="6"
            transform="rotate(-90 34.8078 29.8027)"
          />
        </clipPath>
        <filter
          id="filter1_i_1868_3367"
          x="61.7601"
          y="-0.952044"
          width="69.7632"
          height="45.115"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="4.21642"
            operator="erode"
            in="SourceAlpha"
            result="effect1_innerShadow_1868_3367"
          />
          <feOffset dx="-2.52985" dy="2.52985" />
          <feGaussianBlur stdDeviation="1.68657" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1868_3367"
          />
        </filter>
        <clipPath
          id="bgblur_1_1868_3367_clip_path"
          transform="translate(-61.7601 0.952044)"
        >
          <rect
            x="67.2414"
            y="38.6816"
            width="34.153"
            height="58.8005"
            rx="7.44"
            transform="rotate(-90 67.2414 38.6816)"
          />
        </clipPath>
        <filter
          id="filter2_i_1868_3367"
          x="134.137"
          y="6.10255"
          width="31.6009"
          height="30.1191"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="4.93765"
            operator="erode"
            in="SourceAlpha"
            result="effect1_innerShadow_1868_3367"
          />
          <feOffset dx="-2.96259" dy="2.96259" />
          <feGaussianBlur stdDeviation="1.97506" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1868_3367"
          />
        </filter>
        <clipPath
          id="bgblur_2_1868_3367_clip_path"
          transform="translate(-134.137 -6.10255)"
        >
          <rect
            x="140.555"
            y="29.8027"
            width="17.2818"
            height="18.7631"
            rx="6"
            transform="rotate(-90 140.555 29.8027)"
          />
        </clipPath>
        <linearGradient
          id="paint0_linear_1868_3367"
          x1="36.0678"
          y1="8.10156"
          x2="59.9358"
          y2="34.842"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#026051" />
          <stop offset="1" stopColor="#3B5F59" stopOpacity={0} />
          <stop offset="1" stopColor="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1868_3367"
          x1="34.8078"
          y1="39.1843"
          x2="52.0896"
          y2="39.1843"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7FDFC" />
          <stop offset="1" stopColor="#F7FDFC" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1868_3367"
          x1="34.8078"
          y1="31.2585"
          x2="42.2813"
          y2="49.9347"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity={0.5} />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1868_3367"
          x1="76.9032"
          y1="0.523438"
          x2="108.956"
          y2="58.7929"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#026051" />
          <stop offset="1" stopColor="#3B5F59" stopOpacity={0} />
          <stop offset="1" stopColor="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1868_3367"
          x1="67.2414"
          y1="68.0819"
          x2="101.394"
          y2="68.0819"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7FDFC" />
          <stop offset="1" stopColor="#F7FDFC" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1868_3367"
          x1="67.2414"
          y1="43.2438"
          x2="97.9592"
          y2="91.6519"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity={0.5} />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1868_3367"
          x1="141.816"
          y1="8.10156"
          x2="165.684"
          y2="34.842"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#026051" />
          <stop offset="1" stopColor="#3B5F59" stopOpacity={0} />
          <stop offset="1" stopColor="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1868_3367"
          x1="140.555"
          y1="39.1843"
          x2="157.837"
          y2="39.1843"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7FDFC" />
          <stop offset="1" stopColor="#F7FDFC" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint8_linear_1868_3367"
          x1="140.555"
          y1="31.2585"
          x2="148.029"
          y2="49.9347"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity={0.5} />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_1868_3367"
          x1="88.9614"
          y1="50.8223"
          x2="112.768"
          y2="77.4943"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#026051" />
          <stop offset="1" stopColor="#3B5F59" stopOpacity={0} />
          <stop offset="1" stopColor="#47A092" />
        </linearGradient>
      </defs>
    </svg>
  );
};
